"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tooltipTheme = exports.getTooltipMultilineTitleTypeRampProps = void 0;
var _designTokens = require("@smartsheet/design-tokens");
var _designTokensReact = require("@smartsheet/design-tokens-react");
var _sdsThemeInternal = require("@smartsheet/sds-theme-internal");
var _tooltipConstants = require("./tooltipConstants");
const tooltipTheme = (0, _sdsThemeInternal.themed)({
  background: {
    "lodestar-light": (0, _designTokensReact.color)("color--background--spectrum-slate--strongest"),
    "ursa-light": (0, _designTokensReact.color)("color--background--neutral-inverse--strong")
  },
  borderRadius: {
    "lodestar-light": _designTokens.border.radius05,
    "ursa-light": _designTokens.border.radius20
  },
  textColor: {
    body: (0, _designTokensReact.color)("color--text--neutral-inverse--default"),
    title: (0, _designTokensReact.color)("color--text--neutral-inverse--default")
  },
  fontSize: {
    // Yay these are all the same.
    basic: _designTokens.typography.fontSize.size20,
    multiLineTitle: {
      "lodestar-light": "13px",
      "ursa-light": _designTokens.typography.fontSize.size30
    },
    multiLine: {
      "lodestar-light": "13px",
      "ursa-light": _designTokens.typography.fontSize.size20
    },
    multilineTitleDeprecated: {
      "lodestar-light": "13px",
      "ursa-light": _designTokens.typography.fontSize.size30
    }
  },
  fontWeight: {
    body: _designTokens.typography.fontWeight.regular,
    title: _designTokens.typography.fontWeight.semiBold
  },
  lineHeight: {
    body: {
      "lodestar-light": _designTokens.typography.lineHeight.size30,
      "ursa-light": _designTokens.typography.lineHeight.size20
    },
    title: _designTokens.typography.lineHeight.size30
  },
  padding: {
    body: {
      "lodestar-light": "3px 8px",
      "ursa-light": _designTokens.space.space30
    },
    // These styles are from the old Lodestar version that didn't use the TooltipBody so these
    // components provided all the necessary padding.
    multiLineDeprecated: {
      title: {
        "lodestar-light": `${_designTokens.space.space20} ${_designTokens.space.space40} ${_designTokens.space.space10}`,
        "ursa-light": `${_designTokens.space.space30} ${_designTokens.space.space30} ${_designTokens.space.space10}`
      },
      subtext: {
        "lodestar-light": `0 ${_designTokens.space.space40} ${_designTokens.space.space30}`,
        "ursa-light": `0 ${_designTokens.space.space30} ${_designTokens.space.space30}`
      },
      subtextShift: {
        "lodestar-light": "-8px",
        "ursa-light": "-4px"
      }
    },
    // These styles require the TooltipBody to wrap the components that use them.
    multiLine: {
      title: {
        "lodestar-light": `9px ${_designTokens.space.space20} ${_designTokens.space.space10}`,
        "ursa-light": `0 0 ${_designTokens.space.space10}`
      },
      text: {
        "lodestar-light": `0 ${_designTokens.space.space20}`,
        "ursa-light": `0`
      },
      // The distance between tooltip text siblings. The title has the gap between title and
      // text.
      textGap: {
        "lodestar-light": _designTokens.space.space10,
        "ursa-light": _designTokens.space.space20
      },
      textEndGap: {
        // This is the special gap added to get the right padding-bottom in the Lodestar
        // version of the multiline tooltip.
        "lodestar-light": "9px",
        "ursa-light": "0"
      }
    }
  },
  motion: {
    slide: {
      "lodestar-light": `${_tooltipConstants.ANIMATION_DURATION}ms cubic-bezier(0.23, 1, 0.32, 1)`,
      "ursa-light": _designTokens.motion.animation.default
    },
    opacity: {
      "lodestar-light": `${_tooltipConstants.ANIMATION_DURATION / 2}ms`,
      "ursa-light": _designTokens.motion.animation.default
    }
  }
});
exports.tooltipTheme = tooltipTheme;
const getTooltipMultilineTitleTypeRampProps = themeMode => {
  switch (themeMode) {
    case "ursa-light":
    case "ursa-dark":
      return {
        system: "ursa",
        variant: "Inter--14px--600w"
      };
    case "lodestar-light":
    case "oldestar":
    default:
      return {
        system: "lodestar",
        variant: "headerSmall"
      };
  }
};
exports.getTooltipMultilineTitleTypeRampProps = getTooltipMultilineTitleTypeRampProps;
//# sourceMappingURL=tooltipTheme.js.map